import { Component, ComponentInterface, Element, h, Prop, VNode } from '@stencil/core';

import { uniWatermark } from '@uni/license';
import { UniTemplate } from '@uiwebkit/common';

@Component({ tag: 'uni-title' })
export class UniTitleComponent implements ComponentInterface {

  @Element() el!: HTMLElement;

  @Prop({ reflect: true }) inactive: boolean = false;

  @Prop({ mutable: true }) activate: boolean = false;

  @Prop({ reflect: true }) value: string;

  render(): VNode {
    return UniTemplate(<slot />);
  }

  componentDidRender(): void {
    if (!this.inactive || this.activate) {
      document.head.querySelector('title').innerText = this.value || this.el.textContent;

      setTimeout(() => this.activate = false);
    }
  }

  componentDidLoad(): void {
    uniWatermark('pro');
  }
}
